<template>
  <AdminModal
    :is-open="isOpen"
    modalSize="lg"
    :modal-title="`${this.selectedPopup ? '팝업 상세' : '팝업 추가'}`"
    :close="close"
    :loading="loading"
    :confirmButtonTitle="`${this.selectedPopup ? '수정' : '추가'}`"
    :confirm="update"
    name="popupDetailModal"
  >
    <b-container>
      <b-row>
        <b-col cols="12">제목</b-col>
        <b-col cols="12">
          <b-form-input
            id="popup-title"
            placeholder="팝업 제목을 입력해주세요."
            v-model="title"
            maxlength="200"
          />
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col cols="12">내용</b-col>
        <b-col cols="12">
          <b-form-textarea
            id="popup-content"
            v-model="content"
            placeholder="팝업 내용을 입력해주세요."
            rows="4"
            max-rows="8"
            required
          />
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col cols="12">활성화 상태</b-col>
        <b-col cols="12">
          <b-form-radio-group
            v-model="isActive"
            :options="activeOptions"
            class="mb-3"
            value-field="value"
            text-field="text"
          />
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col cols="12">닫기 가능 여부</b-col>
        <b-col cols="12">
          <b-form-radio-group
            v-model="isClosable"
            :options="closableOptions"
            class="mb-3"
            value-field="value"
            text-field="text"
          />
          <small class="text-muted">닫기 불가능한 팝업은 사용자가 임의로 닫을 수 없습니다.</small>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col cols="12">표시 순서</b-col>
        <b-col cols="12">
          <b-form-input
            id="popup-display-order"
            type="number"
            min="0"
            placeholder="표시 순서 (숫자가 작을수록 먼저 표시)"
            v-model.number="displayOrder"
          />
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col cols="4">
          <label for="popup-start-date">표시 시작일</label>
          <VueDatePicker
            v-model="startDate"
            format="yyyy-MM-dd HH:mm:ss"
            :clearable="true"
            placeholder="표시 시작일을 선택하세요"
            auto-apply
          />
          <small class="text-muted">비어있으면 즉시 표시됩니다.</small>
        </b-col>
        <b-col cols="4">
          <label for="popup-end-date">표시 종료일</label>
          <VueDatePicker
            v-model="endDate"
            format="yyyy-MM-dd HH:mm:ss"
            :clearable="true"
            placeholder="표시 종료일을 선택하세요"
            auto-apply
          />
          <small class="text-muted">비어있으면 계속 표시됩니다.</small>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col>
          <b-input-group prepend="버튼 텍스트">
            <b-form-input
              id="popup-button-text"
              placeholder="버튼에 표시될 텍스트 (선택사항)"
              v-model="buttonText"
              maxlength="50"
            />
          </b-input-group>
        </b-col>
        <b-col>
          <b-input-group prepend="버튼 URL">
            <b-form-input
              id="popup-button-url"
              placeholder="버튼 클릭 시 이동할 URL (선택사항)"
              v-model="buttonUrl"
              maxlength="500"
            />
          </b-input-group>
          <small class="text-muted">http:// 또는 https://로 시작하면 새 탭에서 열립니다.</small>
        </b-col>
      </b-row>

      <b-row class="text-right mt-2">
        <b-form>
          <b-form-textarea
            v-model="memo"
            placeholder="관리용 메모 (사용자에게 표시되지 않음)"
            rows="3"
            max-rows="6"
          />
        </b-form>
      </b-row>

      <b-row v-if="selectedPopup" class="mt-2">
        <b-col cols="6">
          <label>생성일</label>
          <div>{{ getDate(selectedPopup.createdAt) }}</div>
        </b-col>
        <b-col cols="6">
          <label>수정일</label>
          <div>{{ getDate(selectedPopup.updatedAt) }}</div>
        </b-col>
      </b-row>
    </b-container>
  </AdminModal>
</template>

<script>
import AdminModal from "@/components/modals/AdminModal.vue";
import customDate from "@/util/custom-date"
import api from "@/api/api"

export default {
  name: "NoticeModalDetailModal",
  components: { AdminModal },
  data() {
    return {
      id: null,
      title: "",
      content: "",
      isActive: false,
      isClosable: true,
      displayOrder: 0,
      startDate: null,
      endDate: null,
      buttonText: "",
      buttonUrl: "",
      memo: "",
      loading: false,
      activeOptions: [
        { value: true, text: '활성' },
        { value: false, text: '비활성' },
      ],
      closableOptions: [
        { value: true, text: '닫기 가능' },
        { value: false, text: '닫기 불가능' },
      ]
    }
  },
  props: ['isOpen', 'close', 'reload', 'selectedPopup'],
  watch: {
    isOpen(newVal) {
      if (newVal) {
        // 모달이 열릴 때마다 데이터 초기화
        this.initializeData()
      }
    },
    selectedPopup(newVal) {
      if (this.isOpen) {
        // selectedPopup이 변경되고 모달이 열려있을 때 데이터 초기화
        this.initializeData()
      }
    }
  },
  mounted() {
    if (this.isOpen) {
      this.initializeData()
    }
  },
  methods: {
    initializeData() {
      if (this.selectedPopup) {
        // 수정 모드: 기존 데이터 로드
        this.id = this.selectedPopup.id
        this.title = this.selectedPopup.title
        this.content = this.selectedPopup.content
        this.isActive = this.selectedPopup.active 
        this.isClosable = this.selectedPopup.closable
        this.displayOrder = this.selectedPopup.displayOrder
        this.startDate = this.formatDateForInput(this.selectedPopup.startDate)
        this.endDate = this.formatDateForInput(this.selectedPopup.endDate)
        this.buttonText = this.selectedPopup.buttonText || ""
        this.buttonUrl = this.selectedPopup.buttonUrl || ""
        this.memo = this.selectedPopup.memo || ""
        
        console.log('isActive', this.isActive)
        console.log('isClosable', this.selectedPopup.isClosable)
        console.log('isActive', this.selectedPopup.isActive)
        console.log('isClosable', this.selectedPopup.closable)
        console.log('isActive', this.selectedPopup.active)
      } else {
        // 새 팝업 생성 모드: 폼 초기화
        this.resetForm()
      }
    },

    resetForm() {
      this.id = null
      this.title = ""
      this.content = ""
      this.isActive = false
      this.isClosable = true
      this.displayOrder = 0
      this.startDate = null
      this.endDate = null
      this.buttonText = ""
      this.buttonUrl = ""
      this.memo = ""
    },

    getDate(date) {
      return customDate.stringFormat(date)
    },

    formatDateForInput(dateString) {
      if (!dateString) return null
      // "2025-07-15 14:30:00" -> Date 객체로 변환 (VueDatePicker용)
      return new Date(dateString)
    },

    formatDateForAPI(dateInput) {
      if (!dateInput) return null
      // Date 객체 -> "2025-07-15T14:30:00" (API용)
      const date = new Date(dateInput)
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      const seconds = String(date.getSeconds()).padStart(2, '0')

      return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`
    },

    validateForm() {
      if (!this.title.trim()) {
        this.$toast.error('제목을 입력해주세요.', {
          position: "top-right",
          duration: 2000
        })
        return false
      }

      if (!this.content.trim()) {
        this.$toast.error('내용을 입력해주세요.', {
          position: "top-right",
          duration: 2000
        })
        return false
      }

      if (this.startDate && this.endDate) {
        const start = new Date(this.startDate)
        const end = new Date(this.endDate)
        if (start >= end) {
          this.$toast.error('종료일은 시작일보다 늦어야 합니다.', {
            position: "top-right",
            duration: 2000
          })
          return false
        }
      }
      

      return true
    },

    update() {
      if (!this.validateForm()) return

      this.loading = true

      const requestData = {
        title: this.title.trim(),
        content: this.content.trim(),
        isActive: this.isActive,
        isClosable: this.isClosable,
        displayOrder: this.displayOrder,
        startDate: this.formatDateForAPI(this.startDate),
        endDate: this.formatDateForAPI(this.endDate),
        buttonText: this.buttonText.trim() || null,
        buttonUrl: this.buttonUrl.trim() || null,
        memo: this.memo.trim() || null
      }

      if (this.selectedPopup) {
        // 수정
        api.noticeModal.updateModal({
          id: this.id,
          ...requestData
        }, (response) => {
          this.loading = false
          this.$toast.success('팝업이 수정되었습니다.', {
            position: "top-right",
            duration: 2000
          })
          this.reload()
          this.close()
        }, (err) => {
          this.loading = false
          console.log(err)
          this.$toast.error(err.message || '팝업 수정에 실패했습니다.', {
            position: "top-right",
            duration: 2000
          })
        })
      } else {
        // 생성
        api.noticeModal.createModal(requestData, (response) => {
          this.loading = false
          this.$toast.success('팝업이 추가되었습니다.', {
            position: "top-right",
            duration: 2000
          })
          this.reload()
          this.close()
        }, (err) => {
          this.loading = false
          console.log(err)
          this.$toast.error(err.message || '팝업 추가에 실패했습니다.', {
            position: "top-right",
            duration: 2000
          })
        })
      }
    }
  }
}
</script>

<style scoped>
.form-control-plaintext {
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
  margin-bottom: 0;
  line-height: 1.5;
  color: #495057;
  background-color: transparent;
  border: solid transparent;
  border-width: 1px 0;
}
</style>